<template>
  <RegisterPage
    :errors="errors"
    :title="$t('Create a freelancer account')"
    :inviter="inviter"
    :prefilled-email="prefilledEmail"
  >
    <template #left>
      <LeftRegisterFreelancer />
    </template>

    <template #inputs-hidden>
      <input type="hidden" name="account_type" value="freelancer" />
      <input type="hidden" name="inviter_token" :value="inviter.token" />
    </template>
  </RegisterPage>
</template>

<script>
import LeftRegisterFreelancer from '@/components/auth/left/LeftRegisterFreelancer.vue'
import RegisterPage from '@/components/auth/RegisterPage.vue'

export default {
  name: 'RegisterFreelancerPage',
  components: {
    LeftRegisterFreelancer,
    RegisterPage,
  },
  props: {
    errors: {
      type: Object,
      required: true,
    },
    inviter: {
      type: Object,
      required: true,
      default: {},
    },
    prefilledEmail: {
      type: String,
      required: false,
    },
  },
}
</script>
